import React, { useEffect, useState } from "react";
import Dropdown from "react-dropdown";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { useDispatch, useSelector } from "react-redux";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";

function SelectLocation() {
  // ...............................City DDL.......................................
  const dispatch = useDispatch();
  const [display, setDisplay] = useState(false);

  const [citySearch, setCitySearch] = useState("");
  const [cityId, setcityId] = useState("");

  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  useEffect(() => {
    // setcityId(fetchCityData());
    dispatch(fetchCityData());
  }, [dispatch]);

  const handleCitySelect = (selectedOption) => {
    if (selectedOption === null) {
      setcityId(null);
    } else {
      setcityId(selectedOption.value);
    }
  };

  // ...............................City DDL.......................................

  return (
    <>
      <ReactSelect
        options={cityList}
        onChange={handleCitySelect}
        value={cityList.find((option) => option.value === cityId) || null}
        isClearable
        placeholder="Select city"
        styles={customStyles}
        classNamePrefix="react-select"
        className="form-control banner-city"
        onInputChange={(inputValue) => {
          setCitySearch(inputValue);
        }}
        invalid={display && citySearch === ""}
      />
    </>
  );
}

export default SelectLocation;
